module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-02-6624fb371841afceee9486071bda00c2.webp";